const r = (e, o) => {
  if (!o)
    return;
  const t = Object.values(o);
  for (const n of t)
    n.name && n.name.startsWith("Ds") && !e.component(n.name) && e.component(n.name, n);
};
export {
  r as registerGlobalComponents
};
//# sourceMappingURL=design-system.es27.js.map
